import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=4a9d3ea9&"
import script from "./spec.vue?vue&type=script&lang=js&"
export * from "./spec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports